import React from 'react';
import { useParams } from 'react-router';

import { useDataTable } from '@/shared/components/ui/data-table/context/data-table-context';
import { AddResourcesToGroup } from '@/shared/features/groups/components/add-resources-to-group/add-resources-to-group';
import { UNGROUPED_RESOURCES_GROUP_ID } from '@/shared/features/groups/components/group-list/group-list.constants';
import { TGroupResourceBatchActionsProps } from '@/shared/features/groups/components/group-resource-batch-actions/group-resource-batch-actions.types';
import { MoveResources } from '@/shared/features/groups/components/move-resources/move-resources';
import { RemoveResourcesFromGroup } from '@/shared/features/groups/components/remove-resources-from-group/remove-resources-from-group';
import { useGroupsConfig } from '@/shared/features/groups/context/groups-config-context';
import {
  TPermissionCheck,
  TPermissionCheckRule,
} from '@/shared/features/permissions/permission-check.types';

export const GroupResourceBatchActions: React.FC<
  TGroupResourceBatchActionsProps
> = ({ selectedItems, onSuccess }) => {
  const { groupId } = useParams();
  const { getItemId } = useDataTable();
  const { getUpdatePermissionAction } = useGroupsConfig().useResourceElements();

  const getPermission = (): TPermissionCheck | undefined => {
    const rules: TPermissionCheckRule[] = [];

    for (const item of selectedItems) {
      const action = getUpdatePermissionAction(item.__typename);

      if (!action) {
        return undefined;
      }

      rules.push({
        action,
        ids: getItemId(item),
      });
    }

    if (!rules.length) {
      return undefined;
    }

    return rules.length === 1 ? rules[0] : rules;
  };

  if (groupId === UNGROUPED_RESOURCES_GROUP_ID) {
    return (
      <AddResourcesToGroup
        resources={selectedItems}
        onSuccess={onSuccess}
        component="Button"
        permission={getPermission()}
      />
    );
  }

  return (
    <>
      <MoveResources
        component="Button"
        resources={selectedItems}
        onSuccess={onSuccess}
        permission={getPermission()}
      />
      <RemoveResourcesFromGroup
        component="Button"
        resources={selectedItems}
        onSuccess={onSuccess}
        permission={getPermission()}
      />
    </>
  );
};
